require('./modules/topicsnav.js');
require('./modules/loadmore.js');
require('./modules/navigation.js');
require('./modules/toggle-container.js');
const Lazyembed = require('./modules/lazyembed.js');
const Suggest = require('./modules/autosuggest.js');
const Filter = require('./modules/postsfilter.js');
import Glossar from './modules/Glossar.js';

var supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
if (supportsTouch) {
  jQuery('body').addClass('touch-device');
}

if (!window.OnetrustActiveGroups) {
  window.OnetrustActiveGroups = ',C0001,';
}

if (!window.OptanonActiveGroups) {
  window.OptanonActiveGroups = ',C0001,';
}

jQuery(document).ready(function () {
  var $container = jQuery('body.single-post main');

  if ($container.length > 0) {
    $container.each(function (i, el) {
      new Glossar().initialize({
        el: el
      });
    })
  }
})
// (function (w, d, s, l, i) {
//   // var el = document.getElementById('optanon-wrapper');
//   w[l] = w[l] || [];
//   w[l].push({
//     'gtm.start':
//       new Date().getTime(), event: 'gtm.js'
//   });
//   var f = d.getElementsByTagName(s)[0],
//     j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
//   j.async = true;
//   // j.setAttributeNode(d.createAttribute('data-ot-ignore'));
//   // j.setAttribute('class','optanon-category-C0003');
//   // j.type="text/plain";
//   j.defer = true;
//   j.src =
//     'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
//   f.parentNode.insertBefore(j, f);
//
//
// })(window, document, 'script', 'dataLayer', 'GTM-PD4H6R');

jQuery(document).ready(function ($) {
  Suggest.initialize();
  var $el = $('[data-posts-filter]');
  if ($el.length === 1) {
    Filter.initialize({
      el: $el
    })
  }


  let $dataPrimaryTag = $('[data-primary-tag]');
  let $dataSecondaryTag = $('[data-secondary-tag]');
  if ($dataPrimaryTag.length === 1) {
    window.dataLayer = window.dataLayer || [];
    let primTag = $dataPrimaryTag.data('primaryTag');
    if (primTag !== '') {
      dataLayer.push({
        "primaryTag": $dataPrimaryTag.data('primaryTag')
      });
    }
  }

  if ($dataSecondaryTag.length === 1) {
    window.dataLayer = window.dataLayer || [];
    let secTag = $dataSecondaryTag.data('secondaryTag');
    if (secTag !== '') {
      dataLayer.push({
        "secondaryTag": $dataSecondaryTag.data('secondaryTag')
      });

    }
  }

  setTimeout(function () {
    Lazyembed.initialize()
    window.dispatchEvent(new Event('optanon'));
  }, 700);

  $("a[href^=http]").each(function () {

    let excludes = [
      'klardenker.kpmg.de',
    ];
    for (let i = 0; i < excludes.length; i++) {
      if (this.href.indexOf(excludes[i]) != -1) {
        return true; // continue each() with next link
      }
    }

    if (this.href.indexOf(location.hostname) == -1) {

      // attach a do-nothing event handler to ensure we can 'trigger' a click on this link
      $(this).click(function () {
        return true;
      });

      $(this).attr({
        target: "_blank",
        title: "Opens in a new window"
      });

      $(this).click(); // trigger it
    }
  })

});